import {Platform, StyleSheet} from 'react-native';
import CommonStyles from '../../../utils/CommonStyles';

// Theme-aware styles factory (docs/DARK-MODE.md). The color-bearing
// CommonStyles.white_bg spread is replaced with an explicit themed
// backgroundColor (identical in light).
const makeStyles = colors =>
  StyleSheet.create({
    recommendedListContainer: {
      paddingBottom: Platform.OS === 'web' ? 16 : 32,
      paddingTop: 16,
    },
    seeAllView: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    seeAllText: {
      fontSize: 14,
      textDecorationLine: 'underline',
    },
    webArrows: {
      flexDirection: 'row',
      alignSelf: 'flex-end',
      gap: 8,
    },
    arrowBg: {
      width: 32,
      height: 32,
      cursor: 'pointer',
      backgroundColor: colors.surface,
    },
    arrowDisabled: {
      opacity: 0.5,
    },
  });

export default makeStyles;
